import React from "react";
import { useOfferClock } from "../hooks/useOfferClock";
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useOfferClock();
  const units = [{
    v: hours,
    l: "Hours"
  }, {
    v: minutes,
    l: "Minutes"
  }, {
    v: seconds,
    l: "Seconds"
  }];
  return <div className="rounded-2xl bg-ink px-4 py-4 text-center text-white" role="timer" aria-live="off" data-id="element-24" data-mp="3q1nivx459rd4">
      <p className="font-display text-sm font-extrabold uppercase tracking-wider text-cta" data-id="element-25" data-mp="3c25qz8vjxxzj">Special offer ends in:</p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-26" data-mp="3h1ifrz5zhf4r">
        {units.map((u, i) => <React.Fragment key={u.l} data-id="element-27" data-mp="324hvggq4gmgb" data-mpi={i}>
            <div className="flex w-[4.5rem] flex-col items-center" data-id="element-28" data-mp="3259j95dh9fw1">
              <span className="w-full rounded-xl bg-white py-2 font-display text-3xl font-black tabular-nums text-ink" data-id="element-29" data-mp="371zy5pdjq5fv">{u.v}</span>
              <span className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-white/70" data-id="element-30" data-mp="10d4rpuzw4klu">{u.l}</span>
            </div>
            {i < 2 && <span className="pt-2 font-display text-3xl font-black text-cta" data-id="element-31" data-mp="y0wtdi1dlqiw">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}